export default function CTABanner() {
  const scrollToForm = () => {
    const element = document.getElementById('inscricao');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-10 sm:py-12 lg:py-16 bg-gradient-to-r from-yellow-500 to-yellow-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-40 h-40 bg-black rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-60 h-60 bg-black rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="max-w-5xl mx-auto px-5 lg:px-10 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div className="text-center lg:text-left">
            <p className="text-black font-black text-xl sm:text-2xl lg:text-3xl xl:text-4xl mb-2">
              Não precisa experiência.
            </p>
            <p className="text-black/80 text-sm sm:text-base lg:text-lg font-medium">
              Buscamos talentos naturais. Sua oportunidade começa em Tangará da Serra - MT.
            </p>
          </div>
          <button onClick={scrollToForm} className="bg-black text-yellow-500 px-10 lg:px-14 py-4 lg:py-5 rounded-full text-sm lg:text-base font-bold hover:bg-gray-900 transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto flex-shrink-0">
            INSCREVA-SE AGORA
          </button>
        </div>
      </div>
    </section>
  );
}